import React, { useContext, useState, useRef, useEffect } from 'react';
import Collapse from 'antd/lib/collapse';
import { ModelContext } from '../../metadata/ModelSource';
import { DeclaredComponent } from '../../DynamicComponent';
import { RemoveBeanBtn } from '../RemoveBeanBtn';
import { ProductInfoContext } from '../../data/ApplicationDataSource';
import { StepsValidationStatusContext } from '../../../context/StepsValidationStatusProvider';
import { getLineProductSetupContext } from '../line/LineForm';
import { MDForm } from '../../metadata/MDForm';
import { ErrorSink } from '../../ErrorSink';
import {ApplicationExtendedAttributes} from '../ApplicationForm';
import {DownOutlined, RightOutlined} from "@ant-design/icons";
const { Panel } = Collapse;

export function AiListForm({ forms, lineCd }) {
  const applicationModel = useContext(ModelContext);
  const ais = applicationModel.getValue('ais') || 0;
  const { productSetup } = useContext(ProductInfoContext);
  const [activeKey, setActiveKey] = useState('0');
  const aisRef = useRef([]);

  const lineProductSetupContext = getLineProductSetupContext(
    productSetup,
    applicationModel,
    lineCd
  );

  const scrollToAIrRef = ref => {
    window.scrollTo(0, ref.offsetTop);
  };

  useEffect(() => {
    if (aisRef.current.length > 0) {
      let lastAI = aisRef.current.length-1;
      scrollToAIrRef(aisRef.current[lastAI]);
      setActiveKey(lastAI.toString())
    }
  }, [aisRef.current.length]);

  useEffect(() => {
    if(ais){
      setActiveKey((ais.length - 1).toString());
    }
  }, [ais.length])

  if(!ais){
    return  null;
  }

  const Header = ({ ai, index }) => {
    const props = {
      style: {
        marginLeft: 'auto'
      },
      path: `ais`,
      proto: {
        partyTypeCd: 'AIParty'
      },
      prefix: `ais[${index}]`,
      type: 'Additional Interests'
    };
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignContent: 'center',
          width:"100%"
        }}
      >
        <span
          style={{ fontSize: '18px', margin: 0, alignSelf: 'center' }}
          className='bold'
          onClick={() => {
            if (activeKey === index.toString()) {
              return setActiveKey('');
            }
            setActiveKey(index.toString());
          }}
        >
          {ai.interestName ? `Additional Interest - ${ai.interestName}` : 'Additional Interest'}
        </span>
        <RemoveBeanBtn {...props} />
      </div>
    );
  };
  return (
    <Collapse
      expandIcon={props => {
        const { panelKey, isActive } = props;
        const onClickHandler = () => {
          if (activeKey === panelKey) {
            return setActiveKey('');
          }
          setActiveKey(panelKey);
        };

        return (
            isActive
                ? <DownOutlined onClick={() => onClickHandler} style={{marginTop:"10px"}} />
                : <RightOutlined onClick={() => onClickHandler} style={{marginTop:"10px"}} />
        );
      }}
      bordered={false}
      activeKey={activeKey}
      defaultActiveKey={'0'}
      accordion
    >
      {ais.map((ai, i) => {
        if (ai.status === 'Deleted') return null;
        const key = ai.id || ai._tempId;
        const form = forms["Ais"];
        if (!form) {
          return (
            <ErrorSink
              key={key}
              message={`form is not defined for AI ${key}`}
            />
          );
        }
        return (
          <Panel
            key={i}
            header={<Header ai={ai} index={i} />}
            className='has-interest-in-panel'
          >
            <div
              key={key}
              ref={element => {
                aisRef.current[i] = element;
              }}
            >
              <MDForm
                key={key}
                prefix={`ais[${i}]`}
                model={applicationModel}
                extendedAttributes={ApplicationExtendedAttributes}
                productSetupContext={lineProductSetupContext}
                presentationMetadata={form}
              >
                <DeclaredComponent declaration={form} />
              </MDForm>
            </div>
          </Panel>
        );
      })}
    </Collapse>
  );
}